<template>
    <div>
        <SignInPC v-if="isPC" />
        <SignInH5 v-else />
    </div>
</template>
<script>
    import SignInH5 from '../components/h5New';
    import SignInPC from '../components/pcNew';
    import { enableAppShare } from '../../../common/js/APP/share';
    export default {
        name: 'Index',
        components: {
            SignInH5,
            SignInPC
        },
        data() {
            return {};
        },
        mounted() {
            enableAppShare({
                title: '必看！腾讯产品10+职级的能力都有什么？',
                desc: '行业Top级专家，带你构建产品经理的终极能力',
                imgUrl: 'https://s21.lgstatic.com/growth/activity/20210301/1614579475411.png'
            });
        }
    };
</script>